import script from "./dempotherSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./dempotherSetup.vue?vue&type=script&setup=true&lang=js"

import "./dempotherSetup.vue?vue&type=style&index=0&id=7c40eed8&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c40eed8"]])

export default __exports__